import { useCallback, useEffect, useState } from 'react';

import { getItems } from '@/modules/inventory/items/redux/ItemCRUD';

import { RequestMaterialItemOption } from '../types';

interface UseRequestMaterialItemsParams {
  companyId: string;
  skip?: boolean;
  onError?: (message: string) => void;
}

export default function useRequestMaterialItems({
  companyId,
  skip = false,
  onError,
}: UseRequestMaterialItemsParams) {
  const [itemOptions, setItemOptions] = useState<RequestMaterialItemOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchItems = useCallback(async (company: string) => {
    if (!company || company === 'global') {
      setItemOptions([]);
      return;
    }

    setLoading(true);
    try {
      const response = await getItems({ companyId: company, pageSize: 500 });
      setItemOptions(
        (response.results || []).map((row) => ({
          id: row.id,
          name: row.name,
          code: row.code,
          supplier_id: row.supplier_id || undefined,
          supplier_name: row.supplier_name || undefined,
          unit_id: row.uom_id || undefined,
          unit_name: row.uom_name || undefined,
        }))
      );
    } catch (_error) {
      onError?.('Không thể tải danh sách vật tư.');
      setItemOptions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (skip || !companyId) return;
    void fetchItems(companyId);
  }, [companyId, skip]);

  const addOption = (option: RequestMaterialItemOption) => {
    setItemOptions((prev) => [...prev, option]);
  };

  return { itemOptions, loading, addOption };
}
